import Button2 from "./Button2";

export default Button2;